import { render, staticRenderFns } from "./liuyan.vue?vue&type=template&id=3f32565e&"
import script from "./liuyan.vue?vue&type=script&lang=js&"
export * from "./liuyan.vue?vue&type=script&lang=js&"
import style0 from "./liuyan.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports